import angular from 'angular'

// components
import toolbarSearchInput from './component/toolbarSearchInput.js'

export default angular
  .module('portalApp.toolBarSearchInput', [])
  .component('toolbarSearchInput', toolbarSearchInput)
  .name
